const API_URL = process.env.REACT_APP_BASE_URL  || 'https://sja.insightbox.co.uk/api'
// const API_URL = process.env.REACT_APP_BASE_URL  || 'https://5409-2405-201-200d-2af7-8cb5-7b81-6218-5ef9.in.ngrok.io'
const MAIN_URL = process.env.REACT_APP_BASE_URL  || 'https://sja.insightbox.co.uk'
// const API_URL = process.env.REACT_APP_BASE_URL  || 'https://1659-2405-201-200d-2a24-3532-358-f8c-50b.in.ngrok.io'
// const API_URL = process.env.REACT_APP_BASE_URL  || 'https://ch-fullcae.herokuapp.com'
export { API_URL,MAIN_URL };